<script>
import CourseSubjectsComponent from '../features/boxes/CourseSubjectsComponent';
import CourseActivitiesView from './CourseActivitiesView';

export default {
  components: {
    'course-activities-view': CourseActivitiesView,
  },
  extends: CourseSubjectsComponent,
};
</script>

<template>
  <div class="ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom">
    <el-collapse>
      <el-collapse-item
        v-for="(subject, subjectIndex) in orderSubjects(section.courseSubjects)"
        :key="subjectIndex"
        :name="subjectIndex"
      >
        <template #title>
          <el-col :span="20">
            <div style="padding-left: 30px">
              <i class="uil uil-book-open" />
              {{ subject.title }}
            </div>
          </el-col>
          <!--
          <el-col :span="2" align="center">
            {{ subject.getTotalActivities() }} Actividades
          </el-col>
		  -->
          <el-col
            :span="2"
            align="center"
          >
            {{ subject.getDuration() }}
          </el-col>
        </template>
        <course-activities-view :course-subject="subject" />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
